import { render, staticRenderFns } from "./StateManager.vue?vue&type=template&id=a19c1d22&lang=pug&"
import script from "./StateManager.vue?vue&type=script&lang=js&"
export * from "./StateManager.vue?vue&type=script&lang=js&"
import style0 from "./StateManager.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a19c1d22')) {
      api.createRecord('a19c1d22', component.options)
    } else {
      api.reload('a19c1d22', component.options)
    }
    module.hot.accept("./StateManager.vue?vue&type=template&id=a19c1d22&lang=pug&", function () {
      api.rerender('a19c1d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/widget/StateManager.vue"
export default component.exports